module.exports = __webpack_public_path__ + "media/images/lp/lp16-463e534f59d2ead416b340de5d884753.webp";